import { createApi } from '@reduxjs/toolkit/dist/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export type VerificationStatusResponse = {
    verifiedDomain: string | null;
    allowUsersWithVerifiedDomainJoinTeam: boolean;
    verificationEmail: string | null;
    teamPrivacyMode: 'invite' | 'private' | 'public';
};

export const teamDomainApi = createApi({
    reducerPath: 'teamDomain',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['VerificationStatus'],
    endpoints: (builder) => ({
        verifyDomain: builder.mutation<string, string>({
            query: (email) => ({
                url: '/team_domain/verification',
                method: 'POST',
                body: { email },
            }),
            invalidatesTags: ['VerificationStatus'],
        }),
        setVerifyDomainClosed: builder.mutation<void, void>({
            query: () => ({
                url: '/team_domain/close-modal',
                method: 'PUT',
            }),
        }),
        getVerificationStatus: builder.query<VerificationStatusResponse, void>({
            query: () => ({
                method: 'GET',
                url: `/team_domain/`,
            }),
            providesTags: ['VerificationStatus'],
        }),
    }),
});

export const { useVerifyDomainMutation, useGetVerificationStatusQuery, useSetVerifyDomainClosedMutation } =
    teamDomainApi;

export default teamDomainApi;
